import { differenceInSeconds } from 'date-fns';
import { useEffect, useState } from 'react';

function calculateDifferenceInSeconds(endAt: string | number | Date | null | undefined) {
  if (typeof endAt === 'undefined' || endAt === null) {
    return 0;
  }

  return Math.max(0, differenceInSeconds(endAt, new Date()));
}

export function useTimer(endsAt: string | number | Date | null | undefined) {
  const [seconds, setSeconds] = useState(() => calculateDifferenceInSeconds(endsAt));

  useEffect(() => {
    setSeconds(calculateDifferenceInSeconds(endsAt));
  }, [endsAt]);

  useEffect(() => {
    if (seconds > 0) {
      const interval = setTimeout(() => {
        setSeconds(calculateDifferenceInSeconds(endsAt));
      }, 1000);

      return () => clearTimeout(interval);
    }
  }, [seconds, endsAt]);

  return seconds;
}
